import React from 'react';
import { getHoursAndMinutes } from '../../../../../utils/helpers';
import classes from './TotalItem.module.scss';

export default function TotalItem({ item, value, rateType }) {
  return (
    <div className={classes.itemContainer}>
      <p className={classes.hours}>
        {rateType === 'hourly' ? getHoursAndMinutes(value) : `${parseFloat(value.toFixed(2).toString())} d`}
      </p>
      <p className={classes.item}>{item}</p>
    </div>
  );
}
